import React from 'react'
import './CheckCashingView.scss'
import {STEPS} from "../../../../constants";
import _ from 'lodash'

import {CASH_A_CHECK_TRANSACTION_STATUSES} from "../../../../constants";

import {
  Message,
} from 'semantic-ui-react'

import { getLanguageScope } from '../../../../helpers'
const _i18n = getLanguageScope('check_cashing_statuses');

class CheckCashingTranStatus extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { transaction_status, transaction_messages } = this.props;

    if(!transaction_status) return null;

    let messageHeader = <Message.Header content={_i18n('unexpected')}/>;
    let messageType = {};

    if(transaction_status === CASH_A_CHECK_TRANSACTION_STATUSES.APPROVED){
      messageHeader = <Message.Header content={_i18n('approved')}/>;
      messageType = {positive: true}
    }

    if(transaction_status === CASH_A_CHECK_TRANSACTION_STATUSES.BAD_IMAGES){
      messageHeader = <Message.Header content={_i18n('bad_images')}/>;
      messageType = {warning: true}
    }

    if(transaction_status === CASH_A_CHECK_TRANSACTION_STATUSES.BAD_MAKER){
      messageHeader = <Message.Header content={_i18n('bad_maker')}/>;
      messageType = {negative: true}
    }

    if(transaction_status === CASH_A_CHECK_TRANSACTION_STATUSES.CANCELED){
      messageHeader = <Message.Header content={_i18n('canceled')}/>;
      messageType = {negative: true}
    }

    if(transaction_status === CASH_A_CHECK_TRANSACTION_STATUSES.INTERNAL){
      messageHeader = <Message.Header content={_i18n('internal')}/>;
      messageType = {negative: true}
    }

    if(transaction_status === CASH_A_CHECK_TRANSACTION_STATUSES.NOT_PARSED){
      messageHeader = <Message.Header content={_i18n('not_parsed')}/>;
      messageType = {negative: true}
    }

    if(transaction_status === CASH_A_CHECK_TRANSACTION_STATUSES.NOT_RECOGNIZED){
      messageHeader = <Message.Header content={_i18n('not_recognized')}/>;
      messageType = {warning: true}
    }

    if(transaction_status === CASH_A_CHECK_TRANSACTION_STATUSES.REVIEW){
      messageHeader = <Message.Header content={_i18n('review')}/>;
      messageType = {positive: true}
    }

    return (
      <Message {...messageType}>
        {messageHeader}
        <Message.List>
          {_.map(transaction_messages, (message, key) => <Message.Item key={key}>{message}</Message.Item>)}
        </Message.List>
      </Message>
    );
  }

}

export default CheckCashingTranStatus;


// WEBPACK FOOTER //
// ./src/components/Applications/CheckCashing/components/CheckCashingTranStatusView.js